import { render, staticRenderFns } from "./DocumentSheet.vue?vue&type=template&id=4cef561c&"
import script from "./DocumentSheet.vue?vue&type=script&lang=ts&"
export * from "./DocumentSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports